"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTypographyStyle = void 0;
var _interface = require("../interface.js");
const getTypographyStyle = (variant, theme) => {
  const themeTypography = theme.typography;
  const fontWeightRegular = themeTypography.fontWeightRegular;
  const fontWeightSemiBold = themeTypography.fontWeightSemiBold;
  const fontWeightBold = themeTypography.fontWeightBold;
  let style = {
    lineHeight: themeTypography.lineHeightH1
  };
  switch (variant) {
    case _interface.typographyVariantEnum.title:
      style.fontSize = themeTypography.fontSizeH1;
      style.fontWeight = fontWeightRegular;
      break;
    case _interface.typographyVariantEnum.titleSemiBold:
      style.fontSize = themeTypography.fontSizeH1;
      style.fontWeight = fontWeightSemiBold;
      break;
    case _interface.typographyVariantEnum.titleBold:
      style.fontSize = themeTypography.fontSizeH1;
      style.fontWeight = fontWeightBold;
      break;
    case _interface.typographyVariantEnum.headline:
      style.fontSize = themeTypography.fontSizeH2;
      style.fontWeight = fontWeightRegular;
      break;
    case _interface.typographyVariantEnum.headlineSemiBold:
      style.fontSize = themeTypography.fontSizeH2;
      style.fontWeight = fontWeightSemiBold;
      break;
    case _interface.typographyVariantEnum.headlineBold:
      style.fontSize = themeTypography.fontSizeH2;
      style.fontWeight = fontWeightBold;
      break;
    case _interface.typographyVariantEnum.subHeadLine:
      style.fontSize = themeTypography.fontSizeH3;
      style.fontWeight = fontWeightRegular;
      break;
    case _interface.typographyVariantEnum.subHeadLineSemiBold:
      style.fontSize = themeTypography.fontSizeH3;
      style.fontWeight = fontWeightSemiBold;
      break;
    case _interface.typographyVariantEnum.subHeadLineBold:
      style.fontSize = themeTypography.fontSizeH3;
      style.fontWeight = fontWeightBold;
      break;
    case _interface.typographyVariantEnum.body:
      style.fontSize = themeTypography.fontSizeH4;
      style.fontWeight = fontWeightRegular;
      break;
    case _interface.typographyVariantEnum.bodySemiBold:
      style.fontSize = themeTypography.fontSizeH4;
      style.fontWeight = fontWeightSemiBold;
      break;
    case _interface.typographyVariantEnum.bodyBold:
      style.fontSize = themeTypography.fontSizeH4;
      style.fontWeight = fontWeightBold;
      break;
    case _interface.typographyVariantEnum.caption:
      style.fontSize = themeTypography.fontSizeH5;
      style.fontWeight = fontWeightRegular;
      break;
    case _interface.typographyVariantEnum.captionSemiBold:
      style.fontSize = themeTypography.fontSizeH5;
      style.fontWeight = fontWeightSemiBold;
      break;
    case _interface.typographyVariantEnum.captionBold:
      style.fontSize = themeTypography.fontSizeH5;
      style.fontWeight = fontWeightBold;
      break;
    case _interface.typographyVariantEnum.label:
      style.fontSize = themeTypography.fontSizeH6;
      style.fontWeight = fontWeightRegular;
      break;
    case _interface.typographyVariantEnum.labelSemiBold:
      style.fontSize = themeTypography.fontSizeH6;
      style.fontWeight = fontWeightSemiBold;
      break;
    case _interface.typographyVariantEnum.labelBold:
      style.fontSize = themeTypography.fontSizeH6;
      style.fontWeight = fontWeightBold;
      break;
    case _interface.typographyVariantEnum.span:
      style.fontSize = themeTypography.fontSizeLabel;
      style.fontWeight = fontWeightRegular;
      break;
    case _interface.typographyVariantEnum.spanSemiBold:
      style.fontSize = themeTypography.fontSizeLabel;
      style.fontWeight = fontWeightSemiBold;
      break;
    case _interface.typographyVariantEnum.spanBold:
      style.fontSize = themeTypography.fontSizeLabel;
      style.fontWeight = fontWeightBold;
      break;
  }
  return style;
};
exports.getTypographyStyle = getTypographyStyle;